<script>
  import Nenuphar from "@/components/Nenuphar.vue";
  import Reflect from "@/components/Reflect.vue";

  export default {
    name: "AppFooter",
    components: {
      Reflect,
      Nenuphar,
    }
  }
</script>

<template>
  <div class="white-line"></div>
  <footer>
    <div style="position: absolute; top: 40%; left: 20%; width: 80px; height: 25px; animation-duration: 4s, 8s;">
      <Reflect />
    </div>
    <div style="position: absolute; bottom: 30%; right: 26%; width: 50px; height: 15px; animation-duration: 3.5s, 9s; animation-delay: 3s, 0.5s;">
      <Reflect />
    </div>
    <div style="position: absolute; top: 18%; left: 52%; width: 60px; height: 25px; animation-duration: 4s, 6s; animation-delay: 1s, 2s;">
      <Reflect />
    </div>
    <div class="reflect-ctn">
      <h4 class="l1">Numa VERPILLON</h4>
      <h4 class="reflect l1">Numa VERPILLON</h4>
    </div>
    <div class="reflect-ctn">
      <router-link class="ft-link" to="/legals"><p class="l2">Mentions légales</p></router-link>
      <p class="reflect l2">Mentions légales</p>
    </div>
    <div class="reflect-ctn">
      <router-link class="ft-link" to="/contact"><p class="l3">Contact</p></router-link>
      <p class="reflect l3">Contact</p>
    </div>
    <div id="nenuphar1" style="position: absolute; top: 20%; right: 12%; transform: scale(0.8)">
      <Nenuphar />
    </div>
    <div id="nenuphar2" style="position: absolute; bottom: 25%; right: 30%; transform: scaleX(-1.05) scale(0.88)">
      <Nenuphar />
    </div>
  </footer>
</template>

<style>
  footer{
    perspective: 500px;
    position: relative;
    background-color: #7ff1f1;
    color: #266D46;
    font-weight: 460;
    text-align: left;
    padding: 4vh 10vw 6vh 10vw;
  }

  footer h4{
    margin: 0;
    font-weight: 500;
  }

  footer p{
    font-size: 1.5em;
    font-weight: 460;
  }

  .ft-link{
    color: #266D46;
  }

  .ft-link:hover{
    color: #1b2963;
  }

  .white-line{
    background: #fff;
    width: 100%;
    height: 6px;
  }

  .reflect-ctn{
    position: relative;
  }

  .reflect {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    color: #266D46;
    transform: scaleY(-1);
    filter: blur(3px);
    clip-path: polygon(0 10%, 100% 0%, 100% 100%, 0% 90%);
    pointer-events: none;
    opacity: 0.28;
    z-index: -1;
  }

  .l1{
    margin-left: 1.75vw;
    font-size: 2.8em;
  }

  .l3{
    margin-left: -0.8vw;
  }

  @media (max-width: 768px) {
    .l1{
      font-size: 2.4em;
    }
  }

  @media (max-width: 480px) {
    .l1{
      font-size: 1.8em;
    }

    #nenuphar1{
      padding-top: 6vh;
    }
    #nenuphar2{
      display: none;
    }
  }
</style>